import { HttpErrorResponse } from '@angular/common/http';

export enum MoovTokenErrorCode {
  /**
   * @description
   * This error will be return for any request error.
   * For request to get MOOV XAAF token we will receive this error if cookie token expired or invalid.
   */
  AUTHENTICATION_ERROR = '401-9000',
  B2B_PERSONAL_EMAIL_DOMAIN_NOT_ALLOWED = '400-2',
  /**
   * @description
   * This error will be return only for request which contain expired MOOV token (jwt).
   * For request to get new MOOV token we will not receive this error if ATT cookie token expired.
   */
  MOOV_SESSION_EXPIRED = '401-1',
}

export class MoovTokenErrorResponse extends HttpErrorResponse {
  token: string;
  error: {
    errorCode: MoovTokenErrorCode;
    data: string;
    name: string;
    message: string;
  }
}
